import {setToast} from '@assets/actions/layout/setToastAction';
import {logout} from '@assets/actions/user/userAction';
import axios from 'axios';
import {store} from '..';
import {BASE_API} from './const/base';
import {getWindow} from '@assets/helpers/windowHelper';

export async function Http({
  url,
  data = {},
  method = 'GET',
  params = {},
  token = '',
  headers = {}
}) {
  const client = axios.create({
    baseURL: BASE_API,
    timeout: 600000
  });

  // REMOVED: XDebug was causing 10-20x slowdown on production
  // params = {...params, XDEBUG_SESSION_START: 'PHPSTORM'};

  const userToken = getWindow('user.isLoggedIn', false)
    ? getWindow('user.meta.access_token', null)
    : token;

  return client
    .request({
      url,
      method,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userToken}`,
        ...headers
      },
      data,
      params
    })
    .then(res => res.data)
    .catch(function(error) {
      if (error.response) {
        if (error.response.status === 401) {
          store.dispatch(logout());
          store.dispatch(
            setToast({
              isToast: true,
              content: 'Your last login session has expired, please re-login !'
            })
          );
        }
        return error.response.data;
      }
    });
}
export default Http;
